/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { ListItem, OrderedList } from 'carbon-components-react';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { sharedSlackMessages } from '../messages';
import { ConnectAssistantStepMessages as messages } from './messages';

export const ConnectAssistantContent = () => {
  return (
    <>
      <OrderedList className="TabContent__subtitle">
        <ListItem>
          <FormattedMessage
            values={{
              appHome: <strong>{messages.appHome.defaultMessage}</strong>,
              edit: <strong>{messages.edit.defaultMessage}</strong>,
              save: <strong>{messages.save.defaultMessage}</strong>,
              alwaysShowMyBotAsOnline: (
                <strong>
                  {messages.alwaysShowMyBotAsOnline.defaultMessage}
                </strong>
              )
            }}
            {...messages.stepOne}
          />
        </ListItem>
        <ListItem>
          <FormattedMessage
            values={{
              appHome: <strong>{messages.appHome.defaultMessage}</strong>,
              showTabs: <strong>{messages.showTabs.defaultMessage}</strong>,
              messagesTab: (
                <strong>{messages.messagesTab.defaultMessage}</strong>
              ),
              allowUsers: <strong>{messages.allowUsers.defaultMessage}</strong>
            }}
            {...messages.stepTwo}
          />
        </ListItem>
        <ListItem>
          <FormattedMessage
            values={{
              optional: <strong>{messages.optional.defaultMessage}</strong>,
              interactivityAndShortcuts: (
                <strong>
                  {messages.interactivityAndShortcuts.defaultMessage}
                </strong>
              ),
              saveChanges: (
                <strong>
                  {sharedSlackMessages.saveChanges.defaultMessage}
                </strong>
              )
            }}
            {...messages.stepThree}
          />
        </ListItem>
      </OrderedList>
      <div className="TabContent__spacer24" />
    </>
  );
};
